<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import CreateChannel from "./CreateChannel.vue";
import EditChannel from "./EditChannel.vue";

const route = useRoute();

const showCreateChannel = computed(() => {
  return route.name === "DashboardChannelCreate";
});

const showEditChannel = computed(() => {
  return (
    !showCreateChannel.value &&
    (route.name === "DashboardChannels" ||
      route.name === "DashboardChannelsEdit")
  );
});

console.log("DASHBOARD CLIENTS");
</script>
<template>
  <div class="ml-4" style="width: 100%">
    <div class="px-4" style="width: 100%">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="dashboard-title">Canales</h2>
        <router-link
          v-if="route.name === 'DashboardChannels'"
          :to="{ name: 'DashboardChannelCreate' }"
          class="btn btn-primary globals-button"
        >
          Crear Canal
        </router-link>
      </div>
      <CreateChannel v-if="showCreateChannel" :route="route"></CreateChannel>
      <EditChannel v-if="showEditChannel" :route="route"></EditChannel>
    </div>
  </div>
</template>
<style scoped></style>
